import { IClassification } from '@app/pages/cmms/interfaces/classification.interfaces';

export type ClassificationTypeItem = Pick<IClassification, 'name' | 'type'>;
export const CLASSIFICATIONS_TYPES: readonly ClassificationTypeItem[] = [
	{ type: 'AT', name: 'classification_types_at' },
	{ type: 'BCT', name: 'classification_types_bct' },
	{ type: 'CCB', name: 'classification_types_ccb' },
	{ type: 'IFC', name: 'classification_types_ifc' },
];
